import colors from '../scss/private/_colors.module.scss'

export default Object.entries(colors).reduce((colors, [key, color]) => {
  // HACK: В экспорт попадают некоторые классы, начинающиеся с ui-
  // По какому правилу они туда попадают пока не ясно
  // Возможно как-то связано с @include или ::v-deep
  if (!/^ui-/.test(key)) colors[key] = color
  return colors
}, {})
